import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ap_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatApiError = (err) => {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
};

export const SITE = {
  name: "Anton Pears",
  tagline: "French DJ",
  subtitle: "Professionnel & Déclaré",
  phone: "06 17 75 65 61",
  phoneIntl: "+33617756561",
  email: "dj.antonpears@gmail.com",
  ownerName: "Antoine Pitard",
  zones: [
    { code: "16", name: "Charente" },
    { code: "17", name: "Charente-Maritime" },
    { code: "79", name: "Deux-Sèvres" },
    { code: "86", name: "Vienne" },
    { code: "+", name: "Limitrophe Charente" },
  ],
  social: {
    instagram: "https://www.instagram.com/djantonpears?igsh=YjZoNDF0cGc5MWM3",
    facebook: "https://www.facebook.com/profile.php?id=100009113765822",
  },
  logo: "https://customer-assets.emergentagent.com/job_anton-pears-dj/artifacts/ql01gzh1_9b8c5c93-fb07-4320-ba55-572071bce5d9.png",
  hero: "https://customer-assets.emergentagent.com/job_anton-pears-dj/artifacts/2fxdxrnx_IMG_5704.jpg",
  gallery: [
    "https://customer-assets.emergentagent.com/job_anton-pears-dj/artifacts/i5qmv1j9_image.png",
    "https://customer-assets.emergentagent.com/job_anton-pears-dj/artifacts/s9omz4tc_image.png",
    "https://customer-assets.emergentagent.com/job_anton-pears-dj/artifacts/1g7iqih2_11deebba-79f8-492e-bed9-55241c5cc47e.png",
    "https://customer-assets.emergentagent.com/job_anton-pears-dj/artifacts/ea48dovl_d29ce7fe-34d6-46da-8ec8-8a27a5c9ee82.png",
    "https://customer-assets.emergentagent.com/job_anton-pears-dj/artifacts/f00xzopm_e68abdf8-a4f7-4a17-ada3-37cdcb437530.png",
    "https://customer-assets.emergentagent.com/job_anton-pears-dj/artifacts/pfmpwwrm_bedd8192-097b-4e92-a348-9f1e9b34db02.png",
  ],
};
